import React from "react";

const DescEditField = ({ handleInputChange, formData}) => {


  return (
    <div className={"detail-design-history-description edit"}>
      <div className={"label-max-length"}>
        <span className={"label"}>Description</span>
        <span>{`${formData.description.length}/1000`}</span>
      </div>
      <textarea value={formData.description}
                name={"description"}
                maxLength={1000}
                placeholder={"Description"}
                onChange={handleInputChange}
      />
    </div>
  )
}

export default DescEditField;
